/**
 * Access groups API call, maps to the Django endpoint in api/urls.py.
 */
import api from './client';

/** Returns { groups } — every access group, with its join link. */
export const fetchAccessGroups = () => api.get('/api/access-groups/');